import { defineMessage } from 'services/localization';

export const messages = {
    closingPopupMessage: defineMessage('please_remember_to_migr_oid_manual_set_up_later'),
    closeButtonText: defineMessage('skip_migration'),
};
